export const getBlobErrorMessage = async (data) => {
    if (!(data instanceof Blob)) {
      return data?.message || null
    }
  
    try {
      const text = await data.text()
      const jsonData = JSON.parse(text)
      return jsonData.message || jsonData.error || text
    } catch {
      return null
    }
  }